import { Directive, Input, TemplateRef } from "@angular/core";

/**
 * This structural directive is used to mark an <ng-template> given to the ExpansionPanel component to indicate where they should go.
 *
 * Usage with <h-expansion-panel> component :
 *
 * ```
 * <h-expansion-panel>
 *   <ng-template [hExpansionPanelPart]="'header'">
 *     <h3>Title</h3>
 *   </ng-template>
 *   <div *expansionPanelPart="'content'"></div>
 * </h-expansion-panel>
 * ```
 */
@Directive({
    selector: "[hExpansionPanelPart], [expansionPanelPart]",
    exportAs: "expansionPanelPart",
    standalone: true,
})
export class ExpansionPanelPartDirective {
    /**
     * Where the marked template should be displayed.
     */
    @Input()
    public hExpansionPanelPart!: "header" | "content" | "expansionPanel";

    constructor(public templateReference: TemplateRef<HTMLElement>) {}
}
